export function useFeatureFlagTalonOne() {
  var isTalonOneEnabled = useState('ff-isTalonOneEnabled', function () {
    return false;
  });
  return {
    isTalonOneEnabled: readonly(isTalonOneEnabled),
    setIsTalonOneEnabled: function setIsTalonOneEnabled(val) {
      isTalonOneEnabled.value = val;
    }
  };
}